<template>
  <div>
    <b-row
      class="justify-content-between align-items-center align-content-center"
    >
      <b-col sm="12" lg="6">
        <b-btn class="" @click="deliveryScheduleMode = !deliveryScheduleMode">
          <font-awesome-icon icon="clock" class="align-middle small" />
          <span class="font-weight-bold small mx-1"
            >Set Hours of Opertaion</span
          >
        </b-btn>
      </b-col>
      <b-col sm="12" lg="6" class="my-2 my-lg-0">
        <h6 class="font-weight-bold mb-0">
          Current Hours of Opertaion
        </h6>
        <div
          class="d-flex  flex-row justify-content-between py-1 align-content-center align-items-center border-bottom"
          v-for="(value, key) in showNewFormatDefaultSchedule(
            defaultsSchedules
          )"
        >
          <div class="text-left">
            <p class="text-muted mb-0">{{ convertValidDayName(+key) }}</p>
          </div>
          <div class="d-flex flex-column text-left">
            <div v-for="item in value.items">
              <p
                v-if="item.StartTime === 'CLOSED'"
                class="text-dark mb-0"
                style="margin-right: 62px"
              >
               Closed
              </p>
              <p v-else class="text-dark mb-0">
                {{ item.StartTime + " - " + item.EndTime }}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <c-modal
      body-class="p-0"
      :tag="false"
      title="Hours Of Operation Edit"
      hide-footer
      size="xl"
      v-model="deliveryScheduleMode"
    >
      <b-card no-body class="p-0 m-0">
        <b-card-body>
          <operation-schedule-modal
            @cancelSchedule="cancelSchedule"
            :loadBtn="loadBtn"
            :schedules="schedules"
            :renderSchedules="renderSchedules"
            @setTime="setTime"
            type="Closed"
          />
        </b-card-body>
      </b-card>
    </c-modal>
  </div>
</template>

<script>
import operationScheduleModal from "./operationScheduleModal";
import { Switch as cSwitch } from "@/components/shared";
import { mapGetters } from "vuex";
import CModal from "../../shared/Cmodal";
export default {
  name: "operationSchedule",
  components: {
      CModal,
    operationScheduleModal,
    cSwitch,
  },

  data() {
    return {
      // Schedule Data
      editOrderDeliveryMode: false,
      editMessageReceive: false,
      editEmail: false,
      model: {
        AllowSMS: false,
        AllowEmail: false,
        PickupTimeIncrement: 10,
        toleranceId: 5,
        AllowOrderDelivery: false,
        AllowDeliveryBeep: false,
        AutoPaymentConfirm_Deliver: false,
        DeliveryFee1: null,
        DeliveryFee1Type: null,
        DeliveryFee2: null,
        DeliveryFee2Type: null,
        DeliveryMinimumOrder: null,
        DeliveryRadius1: null,
        DeliveryRadius2: null,
        DeliveryPreparationTolerance: null,
        DeliveryPreparation: null,
        DeliveryTimeIncrement: null,
        DeliveryOrderLimit: null,
      },
      tolerance: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 15, text: "15" },
        { value: 20, text: "20" },
        { value: 25, text: "25" },
        { value: 30, text: "30" },
      ],
      editZone1Mode: false,
      editZone2Mode: false,
      deliveryMinMode: false,
      deliveryTimeMode: false,
      editFee1Mode: false,
      editFee2Mode: false,
      editDeliveryPrepMode: false,
      deliveryScheduleMode: false,
      loadBtn: false,
      editdeliveryOrderLimitMode: false,
      defaultsSchedules: [],
      schedules: [],
      renderSchedules: {},
      FeeTypes: [
        { value: "$", text: "$" },
        { value: "%", text: "%" },
      ],
    };
  },
  computed:{
       ...mapGetters([
      "businessProfileGetter",
      // ...
    ]),
  },

  watch: {
    "$store.state.selectedRestaurantId": {
      handler: function(newVal) {
        if (newVal && newVal !== null) {
          let object = {
            RestaurantID: newVal,
            // UserID: localStorage.getItem("userID"),
          };
          //Get settings page options based on selected restaurant
          this.GetRestaurantDeliverySetting(object);
          this.GetRestaurantDeliveryPeriod(object);
        }
      },
      immediate: true,
    },
    "model.AllowEmail"(newVal) {
      //update allow email by toogle check box email
      if (!newVal) {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "EMAIL_DELIVER",
          IsAllowance: 0,
          AllowanceValue: this.model.EmailNotification,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(() => {});
      } else {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "EMAIL_DELIVER",
          IsAllowance: 1,
          AllowanceValue: this.model.EmailNotification,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(() => {});
      }
    },
    "model.AllowSMS"(newVal) {
      //update allow sms by toogle check box email
      if (!newVal) {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "SMS_DELIVER",
          IsAllowance: 0,
          AllowanceValue: this.model.SMSnotification,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then((res) => {
          if (!res.success) {
            this.$showError(res.message);
          }
        });
      } else {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "SMS_DELIVER",
          IsAllowance: 1,
          AllowanceValue: this.model.SMSnotification,
        };
        if (
          this.model.SMSnotification === null ||
          this.model.SMSnotification === ""
        ) {
        } else {
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (!res.success) {
                this.$showError(res.message);
              }
            });
        }
      }
    },
  },

  methods:{
       convertValidDayName(WeekdayId) {
      switch (WeekdayId) {

         case 0:
          return "Sun";
          break;
        case 1:
          return "Mon";
          break;
        case 2:
          return "Tue";
          break;
        case 3:
          return "Wed";
          break;
        case 4:
          return "Thu";
          break;
        case 5:
          return "Fri";
          break;
        case 6:
          return "Sat";
          break;

        default:
          return "";
          break

      }
    },

    GetRestaurantDeliveryPeriod(object) {
      this.$api.getRestaurant
        .GetRestaurantProfile(object)
        .then((res) => {
          if (res.success) {

            let schedules = res.results.RestaurantWorkingHoursAll;
            if (schedules.length) {
              this.defaultsSchedules = schedules.map((item) => ({ ...item }));
              this.schedules = schedules.map((item) => ({ ...item }));
            } else {
              this.schedules = [
                {
                  WeekdayId: 0,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 1,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 2,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 3,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 4,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 5,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
                {
                  WeekdayId: 6,
                  StartTime: "CLOSED",
                  EndTime: "",
                  closed: true,
                },
              ];
              this.defaultsSchedules = this.schedules.map((item) => ({
                ...item,
              }));
            }
            let renderSchedules = {};
            this.schedules.forEach((item) => {
              this.$set(item, "closed", false);
              if (item.StartTime === "CLOSED") {
                item.closed = true;
              }
              renderSchedules[item.WeekdayId] = {
                items: this.schedules.filter(
                  (i) => i.WeekdayId === item.WeekdayId
                ),
                closed: item.closed,
              };
            });
            this.renderSchedules = renderSchedules;
          } else {
            this.$showError(res.message);
          }
        });
    },
    setTime(times) {
      //update schedule pickup hours
      times.forEach((item) => {
        delete item.closed;
      });
      this.loadBtn = true;
      console.log("STOREE",this.$store.state.$businessProfile.FolderId)
      let object = {
        // UserID: localStorage.getItem("userID"),
        RestaurantID: this.$store.state.selectedRestaurantId,
       FolderID: this.$store.state.$businessProfile.FolderId,
        // PickupOrderLimit: Number(this.model.DeliveryOrderLimit),
        // PickupTimeIncrement: Number(this.model.DeliveryTimeIncrement),
        HoursValue: JSON.stringify(times),
      };
      this.$api.getRestaurant
        .UpdateWorkingHours(object)
        .then((res) => {
          if (res.success) {
            this.deliveryScheduleMode = false;
            this.loadBtn = false;
            let model = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem("userID"),
            };
            this.GetRestaurantDeliveryPeriod(model);
          } else {
            this.$showError(res.message);
            this.loadBtn = false;
          }
        })
        .catch(() => {});
    },
    cancelSchedule(data) {
      //close schedule hours pop up modal
      this.deliveryScheduleMode = data;
    },
    showNewFormatDefaultSchedule(array) {
      // show Current Scheduled Pickup Hours
      let obj = {};
      let test = array.map((item) => ({ ...item }));
      test.forEach((item) => {
        this.$set(item, "closed", false);
        if (item.StartTime === "CLOSED") {
          item.closed = true;
        }
        obj[item.WeekdayId] = {
          items: test.filter((i) => i.WeekdayId === item.WeekdayId),
          closed: item.closed,
        };
      });
      return obj;
    },

    GetRestaurantDeliverySetting(object) {
      this.$api.getRestaurant
        .GetRestaurantDeliverySetting(object)
        .then((res) => {
          if (res.success) {
            this.model.AllowOrderDelivery = res.results.AllowOrderDelivery;
            this.model.AllowDeliveryBeep = res.results.AllowDeliveryBeep;
            this.model.AutoPaymentConfirm_Deliver =
              res.results.AutoPaymentConfirm_Deliver;
            this.model.EmailNotification =
              res.results.EmailNotification_Deliver;
            this.model.SMSnotification = res.results.SMSnotification_Deliver.replace(
              "+1",
              ""
            );
            this.model.AllowSMS = res.results.AllowSMS_Deliver;
            this.model.AllowEmail = res.results.AllowEmail_Deliver;
            this.model.DeliveryFee1 = res.results.DeliveryFee1;
            this.model.DeliveryFee1Type = res.results.DeliveryFee1Type;
            this.model.DeliveryFee2 = res.results.DeliveryFee2;
            this.model.DeliveryFee2Type = res.results.DeliveryFee2Type;
            this.model.DeliveryMinimumOrder = res.results.DeliveryMinimumOrder;
            this.model.DeliveryRadius1 = res.results.DeliveryRadius1;
            this.model.DeliveryRadius2 = res.results.DeliveryRadius2;
            this.model.DeliveryPreparationTolerance =
              res.results.DeliveryPreparationTolerance;
            this.model.DeliveryPreparation = res.results.DeliveryPreparation;
            this.model.DeliveryOrderLimit = res.results.DeliveryOrderLimit;
            this.model.DeliveryTimeIncrement =
              res.results.DeliveryTimeIncrement;
          }
        });
    },
    updateAllowance(type, value) {
      //update 3 switches ( To Go orders + Dine in orders + order alarm sound play)
      if (type === "DELIVERYBEEP") {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "DELIVERYBEEP",
          IsAllowance: value ? 0 : 1,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then((res) => {
          if (res.success) {
          } else {
            this.$showError(res.message);
          }
        });
      } else if (type === "DELIVERY") {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "DELIVERY",
          IsAllowance: value ? 0 : 1,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then((res) => {
          if (res.success) {
          } else {
            this.$showError(res.message);
          }
        });
      } else if (type === "AUTOCONFIRMDELIVERY") {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "AUTOCONFIRM_DELIVER",
          IsAllowance: value ? 0 : 1,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then((res) => {
          if (res.success) {
          } else {
            this.$showError(res.message);
          }
        });
      } else if (type === "ZONE1") {
        if (!this.editZone1Mode) {
          this.editZone1Mode = true;
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "ZONE1",
            AllowanceValue: this.model.DeliveryRadius1,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.editZone1Mode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      } else if (type === "ZONE2") {
        if (!this.editZone2Mode) {
          this.editZone2Mode = true;
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "ZONE2",
            AllowanceValue: this.model.DeliveryRadius2,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.editZone2Mode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      } else if (type === "DELIVERYMIN") {
        if (!this.deliveryMinMode) {
          this.deliveryMinMode = true;
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "DELIVERYMIN",
            AllowanceValue: this.model.DeliveryMinimumOrder,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.deliveryMinMode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      } else if (type === "TOLE") {
        let data = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          AllowanceType: "DELIVERYTOLE",
          AllowanceValue: this.model.DeliveryPreparationTolerance,
        };
        this.$api.getRestaurant.UpdateRestaurantAllowance(data).then((res) => {
          if (res.success) {
          } else {
            this.$showError(res.message);
          }
        });
      } else if (type === "DELIVERYTIME") {
        if (!this.editDeliveryPrepMode) {
          this.editDeliveryPrepMode = true;
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "DELIVERYTIME",
            AllowanceValue: this.model.DeliveryPreparation,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.editDeliveryPrepMode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      }
    },
    updateDeliveryFee(type, value) {
      if (type === "Fee1") {
        if (!this.editFee1Mode) {
          this.editFee1Mode = true;
        } else {
          let object = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            FeeMethod: this.model.DeliveryFee1Type,
            FeeType: "1",
            Fee: value,
          };
          this.$api.getRestaurant
            .UpdateRestaurantDeliveryFee(object)
            .then((res) => {
              if (res.success) {
                this.editFee1Mode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      } else if (type === "Fee2") {
        if (!this.editFee2Mode) {
          this.editFee2Mode = true;
        } else {
          let object = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            FeeMethod: this.model.DeliveryFee2Type,
            FeeType: "2",
            Fee: value,
          };
          this.$api.getRestaurant
            .UpdateRestaurantDeliveryFee(object)
            .then((res) => {
              if (res.success) {
                this.editFee2Mode = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      }
    },
    updateDeliveryFeeMethod(type, value) {
      if (type === "Fee1") {
        let object = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          FeeMethod: value,
          FeeType: "1",
          Fee: this.model.DeliveryFee1,
        };
        this.$api.getRestaurant
          .UpdateRestaurantDeliveryFee(object)
          .then((res) => {
            if (res.success) {
            } else {
              this.$showError(res.message);
            }
          });
      } else if (type === "Fee2") {
        let object = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          FeeMethod: value,
          FeeType: "2",
          Fee: this.model.DeliveryFee2,
        };
        this.$api.getRestaurant
          .UpdateRestaurantDeliveryFee(object)
          .then((res) => {
            if (res.success) {
            } else {
              this.$showError(res.message);
            }
          });
      }
    },
    editSmsNotification() {
      //edit sms notification
      if (!this.editMessageReceive) {
        this.editMessageReceive = true;
      } else {
        if (
          this.model.SMSnotification === null ||
          this.model.SMSnotification === ""
        ) {
          this.$showError("text message must not be empty");
        } else if (this.model.SMSnotification.length !== 10) {
          this.$showError("text message must be 10 characters");
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "SMS_DELIVER",
            IsAllowance: 1,
            AllowanceValue: this.model.SMSnotification,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.editMessageReceive = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      }
    },
    editEmailNotification() {
      //edit email notification
      if (!this.editEmail) {
        this.editEmail = true;
      } else {
        if (
          this.model.EmailNotification === null ||
          this.model.EmailNotification === ""
        ) {
          this.$showError("email must not be empty");
        } else if (!this.validationEmail(this.model.EmailNotification)) {
          this.$showError("email is not valid");
        } else {
          let data = {
            // UserID: localStorage.getItem("userID"),
            RestaurantID: this.$store.state.selectedRestaurantId,
            AllowanceType: "EMAIL_DELIVER",
            IsAllowance: 1,
            AllowanceValue: this.model.EmailNotification,
          };
          this.$api.getRestaurant
            .UpdateRestaurantAllowance(data)
            .then((res) => {
              if (res.success) {
                this.editEmail = false;
              } else {
                this.$showError(res.message);
              }
            });
        }
      }
    },
  }
};
</script>
